import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: 1,
        title: 'Architecture​',
        flaticon: 'flaticon-city',
        description: 'With our design and planning expertise, we turn your concepts into reality through expert architecture.',
    },
    {
        count: 2,
        title: 'Landscape Design',
        flaticon: 'flaticon-paint',
        description: 'We expertly create landscapes that blend beauty, functionality, innovation, and practicality seamlessly.',
    },
    {
        count: 3,
        title: 'Furniture Design​',
        flaticon: 'flaticon-crane',
        description: 'Our furniture design service offers unique, tailored pieces that enhance your interior with quality and craftsmanship.',
    },
    {
        count: 4,
        title: 'Interior',
        flaticon: 'flaticon-decorating',
        description: 'Bringing spaces to life with imaginative design solutions that evoke harmony, sophistication, and practicality.',
    },
    {
        count: 5,
        title: 'Professional Opinion',
        flaticon: 'flaticon-chart',
        description: 'Offering expert insights and professional opinions to guide informed decision-making and strategies.',
    },
    {
        count: 6,
        title: 'Accurate Engineering',
        flaticon: 'flaticon-sketch',
        description: 'Engineering excellence through meticulous precision and innovative approaches, tailored to your needs.',
    },
    {
        count: 7,
        title: 'General Builder',
        flaticon: 'flaticon-builder',
        description: 'Skilled in all phases of construction, offering reliable building solutions that meet both your vision and budget.',
    },
    {
        count: 8,
        title: 'Electricity',
        flaticon: 'flaticon-drill',
        description: 'Powering your spaces with high-quality electrical services designed to meet every need.',
    },
    {
        count: 9,
        title: 'Site Planning',
        flaticon: 'flaticon-art-and-design',
        description: 'Custom site development planning that ensures optimal land use and environmental compatibility.',
    }
]

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class OurServices3 extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">All</span> Services</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6">
                                    <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                                        <div className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                            <span className="icon-cell text-secondry"><i className={item.flaticon} /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.title}</h4>
                                            <p>{item.description}</p>
                                            <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices3;